import { z } from 'zod'

export const blockWorkerFormSchema = z.object({
  companyId: z.object({
    id: z
      .number({ invalid_type_error: 'Company ID is required' })
      .int('Company ID must be an integer')
      .positive('Company ID must be a positive integer'),
  }),
  workerId: z.object({
    id: z
      .number({ invalid_type_error: 'Worker ID is required' })
      .int('Worker ID must be an integer')
      .positive('Worker ID must be a positive integer'),
  }),
  action: z.enum(['block', 'unblock']),
  reason: z.string().min(1, 'Reason is required'),
})

export type BlockWorkerFormValues = z.infer<typeof blockWorkerFormSchema>

export type BlockWorkerFormInput = {
  companyId: { id: number | null }
  workerId: { id: number | null }
  action: BlockWorkerFormValues['action']
  reason: string
}
